import { render, staticRenderFns } from "./CreateManualQuoteDialog.vue?vue&type=template&id=6884f852"
import script from "./CreateManualQuoteDialog.vue?vue&type=script&lang=js"
export * from "./CreateManualQuoteDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateManualQuoteDialog.vue?vue&type=style&index=0&id=6884f852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports